import React from 'react';
import NewColumns from './NewColumns'
import FiltersForm from './FiltersForm'
import RemoveColumn from './RemoveColumn'

class Collapsible extends React.Component {
  constructor () {
    super()
    this.state = {
      showBatchUpdate: false,
      showNewColumns: false,
      showFilters: false,
      showRemoveColumn: false
    }
  }

  hide() {
    this.setState({
      showBatchUpdate: false,
      showNewColumns: false,
      showFilters: false,
      showRemoveColumn: false
    })
  }

  getFiltered(filters) {
    this.props.getFiltered(filters)
  }

  render() {

    // const { populateDescription, hasActive, toggleMore, showLength, hideLength, lengthVisible, title_columns_exist, addTitleColumns, feed_id, columns, filters } = this.props
    const { populateDescription, hasActive, toggleMore, showLength, hideLength, lengthVisible, title_columns_exist, addTitleColumns, feed_id, columns } = this.props
    const { showBatchUpdate, showNewColumns, showFilters, showRemoveColumn } = this.state

    const hasActiveClass = hasActive ? "active" : ""
    const collapsibleIcon = hasActive ? "keyboard_arrow_down" : "keyboard_arrow_right"

    const batchUpdateAction = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: true,
          showNewColumns: false,
          showFilters: false,
          showRemoveColumn: false
        })
      }}><i className="material-icons tiny">mode_edit</i>Filters & Batch Options</a>
    )

    const lengthAction = lengthVisible ? (
      <a href="" onClick={(e) => {
        e.preventDefault()
        hideLength()
      }}><i className="material-icons tiny">settings_ethernet</i>Hide Title Length Column</a>
    ) : (
      <a href="" onClick={(e) => {
        e.preventDefault()
        showLength()
      }}><i className="material-icons tiny">settings_ethernet</i>Show Title Length Column</a>
    )

    // const numfilters = filters.length;
    // const number_of_filters = (numfilters > 0) ? (<span className="filterCount">(active: {numfilters})</span>) : ''

    // const set_filters = (
    //   <a href="" onClick={(e) => {
    //     e.preventDefault()
    //     this.setState({
    //       showBatchUpdate: false,
    //       showNewColumns: false,
    //       showFilters: true,
    //       showRemoveColumn: false
    //     })
    //   }}><i className="material-icons tiny">filter_list</i>Filters { number_of_filters }</a>
    // )

    const add_title_columns = title_columns_exist ? '' : (
      <a href="" onClick={(e) => {
        e.preventDefault()
        addTitleColumns()
      }}><i className="material-icons tiny">text_fields</i>Add New Title Columns (x2)</a>
    )

    const add_title_to_description_if_empty = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        populateDescription()
      }}><i className="material-icons tiny">title</i>Add Title to Description if Empty</a>
    )

    const add_columns = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: false,
          showNewColumns: true,
          showFilters: false,
          showRemoveColumn: false
        })
      }}><i className="material-icons tiny">view_column</i>Add New Column(s)</a>
    )

    const remove_columns = (
      <a href="" onClick={(e) => {
        e.preventDefault()
        this.setState({
          showBatchUpdate: false,
          showNewColumns: false,
          showFilters: false,
          showRemoveColumn: true
        })
      }}><i className="material-icons tiny">delete</i>Remove a Column</a>
    )

    const actionsClass = ( showFilters || showBatchUpdate ) ? "hide " : "entryAdditionalActions"
    const flexClass = ( showFilters || showBatchUpdate ) ? "" : "flex"

    return (
      <div>
        <ul id="collapsible_ul" className="collapsible">
          <li className={ hasActiveClass }>
            <div className="collapsible-header" onClick={(e) => {
              toggleMore()
            }}>
              <i className="material-icons">{ collapsibleIcon }</i>More Actions
            </div>
            <div className="collapsible-body">
              <div className={flexClass}>
                <div className={actionsClass}>
                  { batchUpdateAction }
                  { lengthAction }
                  { add_columns }
                  { remove_columns }
                  { add_title_columns }
                  { add_title_to_description_if_empty }
                </div>
                <div className="formContainer">
                  <NewColumns
                    feed_id={feed_id}
                    columns={columns}
                    isHidden={ showNewColumns===false }
                    hide={this.hide.bind(this)}
                  />
                  <FiltersForm
                    feed_id={feed_id}
                    columns={columns}
                    isHidden={ showFilters===false && showBatchUpdate === false }
                    hide={this.hide.bind(this)}
                    getFiltered={this.getFiltered.bind(this)}
                    resetCollapsible={this.props.resetCollapsible.bind(this)}
                    hasUpdate={showBatchUpdate}
                    account_id={this.props.account_id}
                  />
                  <RemoveColumn
                    feed_id={feed_id}
                    columns={columns}
                    isHidden={ showRemoveColumn===false }
                    hide={this.hide.bind(this)}
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    )
  }
}

export default Collapsible;



// WEBPACK FOOTER //
// ./src/js/components/Collapsible.js